export const column1 = [
    {
        label: '序号',
        prop: 'index'
    },
    {
        label: '标题',
        prop: 'title'
    },
    {
        label: '状态',
        prop: 'status'
    },
    {
        width: 120,
        label: '操作人',
        prop: 'insertName'
    },
    {
        width: 160,
        label: '操作时间',
        prop: 'insertDate'
    },
];
export const column2 = [
    {
        label: '序号',
        prop: 'index'
    },
    {
        label: '资讯名称',
        prop: 'name'
    },
    {
        width: 110,
        label: '资讯封面',
        prop: 'img'
    },
    {
        label: '资讯导语',
        prop: 'infoIntroduce'
    },
    {
        label: '资讯状态',
        prop: 'status'
    },
    {
        width: 140,
        label: '资讯链接地址',
        prop: 'linkUrl'
    },
    {
        label: '置顶状态',
        prop: 'topFlag'
    },
    {
        label: '是否包含附件',
        prop: 'attachFlag'
    },
    {
        width: 120,
        label: '发布时间',
        prop: 'publishTime'
    },
    {
        width: 120,
        label: '下架时间',
        prop: 'offShelfTime'
    },
    {
        width: 120,
        label: '操作人',
        prop: 'insertName'
    },
];
export const column3 = [
    {
        label: '序号',
        prop: 'index'
    },
    {
        label: '机构名称',
        prop: 'name'
    },
    {
        width: 110,
        label: '机构宣传图',
        prop: 'img'
    },
    {
        label: '状态',
        prop: 'status'
    },
];

export const tagList = [
    {
        label: '顶部介绍',
        value: 1
    },
    {
        label: '资讯列表',
        value: 2
    },
    {
        label: '合作机构1',
        value: 3
    },
    {
        label: '合作机构2',
        value: 4
    }
];
